export default "__VITE_ASSET__B1lQN_Yv__"